import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { getDescription } from 'helpers/content';
import { setPageTitle } from 'actions/header';
import { getStudentEducationGroups } from 'actions/sections';
import LoadingCards from 'components/Presentation/Cards/LoadingCards';
import { Expandable } from 'UI';
import { Card, Icon, Flex, translate } from '@haldor/ui';
import './_Groups.scss';
var Groups = /*#__PURE__*/function (_Component) {
  function Groups(props) {
    var _this;
    _classCallCheck(this, Groups);
    _this = _callSuper(this, Groups, [props]);
    _defineProperty(_this, "componentDidMount", function () {
      var activeStudent = _this.props.activeStudent;
      _this.props.setPageTitle(_this.props.translate('Groups'));
      _this.props.getStudentEducationGroups(activeStudent.id);
    });
    _defineProperty(_this, "cutDescription", function (description) {
      if (description == null) {
        return '';
      }
      var strippedDescription = getDescription(description).replace(/(<([^>]+)>)/ig, '');
      if (strippedDescription.length > 99) {
        return strippedDescription.slice(0, 100) + '…';
      }
      return strippedDescription;
    });
    _defineProperty(_this, "toggleExpand", function () {
      return _this.setState({
        expand: !_this.state.expand
      });
    });
    _defineProperty(_this, "renderGroup", function (group, index) {
      return /*#__PURE__*/React.createElement(Card, {
        element: Link,
        to: "/groups/".concat(group.id),
        style: {
          marginBottom: '0.75rem'
        },
        key: group.id
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          flex: 1
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "group-header"
      }, /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, group.title), group.type != null ? /*#__PURE__*/React.createElement("div", {
        className: "card-meta",
        style: {
          margin: 0
        }
      }, _this.props.translate(group.type.toUpperCase())) : null), /*#__PURE__*/React.createElement(Expandable, {
        title: "1",
        open: _this.state.expand
      }, /*#__PURE__*/React.createElement(Flex, {
        top: true,
        space: true
      }, /*#__PURE__*/React.createElement("div", {
        className: "description size-14"
      }, _this.cutDescription(group.description))))));
    });
    _defineProperty(_this, "renderFoldButton", function () {
      return /*#__PURE__*/React.createElement(Flex, {
        end: true
      }, /*#__PURE__*/React.createElement("div", {
        className: "all-fold-button color--meta ".concat(_this.state.expand ? 'open' : 'closed'),
        onClick: _this.toggleExpand
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "ArrowLeft"
      }), _this.state.expand ? _this.props.translate('Hide description') : _this.props.translate('Show description')));
    });
    _this.state = {
      expand: false
    };
    return _this;
  }
  _inherits(Groups, _Component);
  return _createClass(Groups, [{
    key: "render",
    value: function render() {
      if (this.props.groups == null) {
        return /*#__PURE__*/React.createElement("div", null);
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "page groups"
      }, this.renderFoldButton(), this.props.groups.length > 0 ? this.props.groups.map(this.renderGroup) : null, this.props.groups.length == 0 ? /*#__PURE__*/React.createElement(LoadingCards, {
        count: 3
      }) : null);
    }
  }]);
}(Component);
var mapStateToProps = function mapStateToProps(state) {
  return {
    groups: state.groups.groups,
    activeStudent: state.User.activeStudent,
    translate: translate(state.Languages.translations)
  };
};
export default connect(mapStateToProps, {
  getStudentEducationGroups: getStudentEducationGroups,
  setPageTitle: setPageTitle
})(Groups);